import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { GamingHubSummary } from './GamingHubSummary';
import { MembershipStatus } from './MembershipStatus';
import { Overlay } from './Overlay';
import { PaymentHubSummary } from './PaymentHubSummary';
import { getMyHubsPowerPack, getMyHubsSummary } from './Portfolio.actions';
import { StakingHubSummary } from './StakingHubSummary';
import { WalletSummary } from './WalletSummary';
import { TradingHubSummary } from './TradingHubSummary';
import { Flexed, TabSelectButton, Tabs } from '../../styles/GlobalComponents';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router';
import {
  MY_HUBS,
  MY_HUBS_AKASHA,
  MY_HUBS_BIG_WHALE,
  MY_HUBS_FLIPME_CARDS,
  MY_HUBS_GAMING,
  MY_HUBS_PAYMENT,
  MY_HUBS_POWERPACKS,
  MY_HUBS_STAKING,
  MY_HUBS_TRADING
} from '../../routes/routes';
import { Conversion } from './Conversion/Conversion';
import { BigWhaleSummary } from './BigWhaleSummary';
import { WithdrawStepsEnum } from './WithdrawHubs/types';
import { TravelSummary } from './TravelSummary';
import { AkashaSummary } from './AkashaSummary';
import { FlipMeBanner } from '../FlipMeWallet/FlipMeBanner';
import { PowerPacksSummary } from './PowerPacks/PowerPacksSummary';

export const Portfolio = () => {
  const dispatch = useAppDispatch();

  const [withdrawStep, setWithdrawStep] = useState<WithdrawStepsEnum>(
    WithdrawStepsEnum.INIT
  );
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { loading, loadingHubs, akashaPackages, powerPackPackages } =
    useAppSelector((state) => state.portfolio);

  const { canBuyAkashaPackages, canBuyPowerPacksPackages } = useAppSelector(
    (state) => state.auth.userInfo
  );

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    dispatch(getMyHubsSummary());
    dispatch(getMyHubsPowerPack());
  }, [dispatch]);

  const pathname = location.pathname;

  if (loading) return <Spinner fullScreen={true} />;

  const showTabs = () => {
    if (
      canBuyPowerPacksPackages ||
      (!canBuyPowerPacksPackages &&
        powerPackPackages?.userPackages?.length !== 0)
    ) {
      return MY_HUBS_POWERPACKS;
    } else if (
      canBuyPowerPacksPackages ||
      (!canBuyPowerPacksPackages && akashaPackages?.userPackages?.length !== 0)
    ) {
      return MY_HUBS_AKASHA;
    }

    return MY_HUBS_BIG_WHALE;
  };

  const showPowerPacksTab = () => {
    if (
      canBuyPowerPacksPackages ||
      (!canBuyPowerPacksPackages &&
        powerPackPackages?.userPackages?.length !== 0)
    ) {
      return (
        <TabSelectButton
          onClick={() => history.push(MY_HUBS_POWERPACKS)}
          selected={pathname === MY_HUBS_POWERPACKS}>
          <div>Power Pack</div>
        </TabSelectButton>
      );
    }
  };

  const showAkashaTab = () => {
    if (
      canBuyAkashaPackages ||
      (!canBuyAkashaPackages && akashaPackages?.userPackages?.length !== 0)
    )
      return (
        <TabSelectButton
          onClick={() => history.push(MY_HUBS_AKASHA)}
          selected={pathname === MY_HUBS_AKASHA}>
          <div>Super Node</div>
        </TabSelectButton>
      );
  };
  return (
    <AnimatedDashboard zoom>
      <WalletSummary />
      <FlipMeBanner isOpen={isOpen} setIsOpen={setIsOpen} />
      <MembershipStatus />

      <Flexed mb='20'>
        <Tabs>
          {showPowerPacksTab()}
          {showAkashaTab()}

          <TabSelectButton
            onClick={() => history.push(MY_HUBS_BIG_WHALE)}
            selected={pathname === MY_HUBS_BIG_WHALE}>
            <div>BigWhale</div>
          </TabSelectButton>

          <TabSelectButton
            onClick={() => history.push(MY_HUBS_TRADING)}
            selected={pathname === MY_HUBS_TRADING}>
            <div>Trading</div>
          </TabSelectButton>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_PAYMENT)}
            selected={pathname === MY_HUBS_PAYMENT}>
            <div>Payment</div>
          </TabSelectButton>

          <TabSelectButton
            onClick={() => history.push(MY_HUBS_GAMING)}
            selected={pathname === MY_HUBS_GAMING}>
            <div>Gaming</div>
          </TabSelectButton>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_STAKING)}
            selected={pathname === MY_HUBS_STAKING}>
            <div>Staking</div>
          </TabSelectButton>
        </Tabs>
      </Flexed>

      {loadingHubs && <Spinner fullScreen={true} transparent />}

      <Switch location={location} key={location.pathname}>
        <Redirect exact from={MY_HUBS} to={showTabs()} />

        <Route path={MY_HUBS_POWERPACKS}>
          <PowerPacksSummary setIsOpen={setIsOpen} />
        </Route>
        <Route path={MY_HUBS_AKASHA}>
          <AkashaSummary />
        </Route>
        {/* <Route path={MY_HUBS_TRAVEL}>
          <TravelSummary />
        </Route> */}
        <Route path={MY_HUBS_BIG_WHALE}>
          <BigWhaleSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
          />
        </Route>
        <Route path={MY_HUBS_TRADING}>
          <TradingHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
          />
        </Route>
        <Route path={MY_HUBS_PAYMENT}>
          <PaymentHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
            setIsOpen={setIsOpen}
          />
        </Route>

        <Route path={MY_HUBS_FLIPME_CARDS}>
          <PaymentHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
            setIsOpen={setIsOpen}
          />
        </Route>
        <Route path={MY_HUBS_GAMING}>
          <GamingHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
            setIsOpen={setIsOpen}
          />
        </Route>
        <Route path={MY_HUBS_STAKING}>
          <StakingHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
          />
        </Route>
      </Switch>

      <Conversion pathname={pathname} />

      <Overlay />
    </AnimatedDashboard>
  );
};
